/* Vosoro theme. Vanilla, no libraries. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Menu drawer ---------- */
  function initDrawer() {
    var drawer = document.getElementById('MenuDrawer');
    if (!drawer || drawer.dataset.ready) return;
    drawer.dataset.ready = '1';
    var openers = $all('.js-drawer-open');
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      document.body.classList.add('drawer-open');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var first = drawer.querySelector('.drawer__links a, button');
      if (first) setTimeout(function () { first.focus(); }, 60);
    }
    function close() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('drawer-open');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      setTimeout(function () { drawer.hidden = true; }, reduceMotion ? 0 : 280);
      if (lastFocus) lastFocus.focus();
    }
    openers.forEach(function (b) { b.addEventListener('click', open); });
    $all('.js-drawer-close', drawer).forEach(function (b) { b.addEventListener('click', close); });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        var f = $all('a[href], button', drawer).filter(function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  /* ---------- Gallery: swipe, counter, arrows ---------- */
  function initGallery(root) {
    $all('.js-gallery', root).forEach(function (g) {
      if (g.dataset.ready) return;
      g.dataset.ready = '1';
      var track = g.querySelector('.js-gallery-track');
      var idx = g.querySelector('.js-gallery-index');
      var dots = $all('.gallery__dot', g);
      if (!track) return;
      // Photos 4 onward are held back until she first touches the gallery (swipe, arrow, dot, thumbnail or keys)
      var held = $all('img[data-srcset], img[data-src]', g);
      function wake() {
        if (!held.length) return;
        held.forEach(function (img) {
          if (img.dataset.srcset) { img.srcset = img.dataset.srcset; img.removeAttribute('data-srcset'); }
          if (img.dataset.src) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
        });
        held = [];
      }
      if (held.length) {
        var zone = g.closest('.pdp__media') || g;
        ['touchstart', 'pointerdown', 'keydown', 'focusin'].forEach(function (ev) { zone.addEventListener(ev, wake, { passive: true, once: true }); });
        track.addEventListener('scroll', wake, { passive: true, once: true });
      }
      function current() { return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); }
      function update() {
        var i = current();
        if (idx) idx.textContent = String(i + 1);
        dots.forEach(function (d, j) { d.classList.toggle('is-on', i === j); if (i === j) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      }
      dots.forEach(function (d, j) { d.addEventListener('click', function () { track.scrollTo({ left: j * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' }); }); });
      track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      function go(d) {
        var n = track.children.length;
        var i = Math.min(Math.max(current() + d, 0), n - 1);
        track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      var prev = g.querySelector('.js-gallery-prev'), next = g.querySelector('.js-gallery-next');
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      });
    });
  }

  /* ---------- Supply rows: sync every selector and every buy button ---------- */
  function initSupply(root) {
    var forms = $all('.js-buy-form', root);
    if (!forms.length) return;
    function apply(variantId, source) {
      $all('.js-buy-form').forEach(function (form) {
        var picked = null;
        $all('input.tier__input', form).forEach(function (r) {
          var on = r.value === String(variantId);
          if (on) picked = r;
          if (r !== source) r.checked = on;
        });
        var btn = form.querySelector('.js-buy-button');
        if (btn && picked) {
          var available = picked.getAttribute('data-available') === 'true';
          btn.disabled = !available;
          btn.textContent = available ? (btn.getAttribute('data-template') || 'Add to cart, [price]').replace('[price]', picked.getAttribute('data-price')) : 'Sold out';
        }
      });
      if (window.history && window.history.replaceState && /\/products\//.test(location.pathname)) {
        var url = new URL(location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url.toString());
      }
    }
    forms.forEach(function (form) {
      if (form.dataset.ready) return;
      form.dataset.ready = '1';
      form.addEventListener('change', function (e) {
        if (e.target && e.target.classList.contains('tier__input')) apply(e.target.value, e.target);
      });
      // Skip cart through the AJAX cart, then straight to checkout. A plain form post to /cart/add
      // can trip Shopify's bot check ("Your connection needs to be verified"); /cart/add.js does not.
      form.addEventListener('submit', function (e) {
        if (form.dataset.submitting) { e.preventDefault(); return; }
        if (!window.fetch || !window.FormData) return; // very old browser: let the normal post happen
        e.preventDefault();
        form.dataset.submitting = '1';
        var btn = form.querySelector('.js-buy-button');
        if (btn) btn.setAttribute('aria-busy', 'true');
        var clear = document.documentElement.getAttribute('data-clear-cart') === 'true';
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var ret = form.querySelector('input[name="return_to"]');
        var dest = ret ? ret.value : null;
        var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
        var picked = form.querySelector('input.tier__input:checked');
        var qty = form.querySelector('input[name="quantity"]');
        var body = JSON.stringify({ items: [{ id: parseInt(picked ? picked.value : 0, 10), quantity: parseInt(qty ? qty.value : 1, 10) || 1 }] });
        var fallback = function () { HTMLFormElement.prototype.submit.call(form); };
        var step = clear
          ? fetch(root + 'cart/clear.js', { method: 'POST', headers: json, credentials: 'same-origin' }).catch(function () {})
          : Promise.resolve();
        step
          .then(function () { return fetch(root + 'cart/add.js', { method: 'POST', headers: json, credentials: 'same-origin', body: body }); })
          .then(function (r) {
            if (!r.ok) throw new Error('add ' + r.status);
            window.location.href = dest || (root + 'cart');
          })
          .catch(fallback);
      });
    });
    window.addEventListener('pageshow', function () {
      forms.forEach(function (f) { delete f.dataset.submitting; var b = f.querySelector('.js-buy-button'); if (b) b.removeAttribute('aria-busy'); });
    });
  }

  /* ---------- Smooth scroll back to the buy box ---------- */
  function initScrollToBuy() {
    $all('.js-scroll-to-buy').forEach(function (a) {
      if (a.dataset.ready) return;
      a.dataset.ready = '1';
      a.addEventListener('click', function (e) {
        var target = document.getElementById('buy-box');
        if (!target) return;
        e.preventDefault();
        var head = target.querySelector('.pdp__title-block') || target;
        var top = head.getBoundingClientRect().top + window.pageYOffset - 12;
        window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
        var checked = target.querySelector('.tier__input:checked');
        if (checked) setTimeout(function () { checked.focus({ preventScroll: true }); }, reduceMotion ? 0 : 600);
      });
    });
  }

  /* ---------- Review ticker: slow auto scroll, pauses on touch, draggable ---------- */
  function initTicker(root) {
    $all('.js-ticker', root).forEach(function (vp) {
      if (vp.dataset.ready) return;
      vp.dataset.ready = '1';
      var track = vp.querySelector('.js-ticker-track');
      if (!track || !track.children.length) return;
      // Duplicate the chips once so the loop is seamless. Copies are hidden from screen readers.
      var originals = Array.prototype.slice.call(track.children);
      var copies = 0;
      while ((copies === 0 || track.scrollWidth < vp.clientWidth * 2.2) && copies < 12) {
        originals.forEach(function (li) {
          var c = li.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          $all('a, button', c).forEach(function (x) { x.setAttribute('tabindex', '-1'); });
          c.removeAttribute('data-shopify-editor-block');
          track.appendChild(c);
        });
        copies++;
      }
      var loopWidth = 0;
      function measureLoop() {
        loopWidth = 0;
        if (copies > 0) {
          var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 8;
          originals.forEach(function (li) { loopWidth += li.getBoundingClientRect().width + gap; });
        }
      }
      // Testimonial cards: a quote never runs past three lines. A longer one widens its card until it fits (Dennis, 2026-09-25).
      function fitCards() {
        var all = Array.prototype.slice.call(track.children);
        var n = originals.length;
        originals.forEach(function (card, i) {
          var q = card.querySelector('.tcard__quote');
          if (!q) return;
          card.style.flexBasis = '';
          var base = card.getBoundingClientRect().width, w = base;
          var lh = parseFloat(getComputedStyle(q).lineHeight) || 21;
          while (q.getBoundingClientRect().height > lh * 3 + 2 && w < base * 2) { w += 8; card.style.flexBasis = w + 'px'; }
          for (var k = i + n; k < all.length; k += n) all[k].style.flexBasis = card.style.flexBasis;
        });
        measureLoop();
      }
      if (track.querySelector('.tcard__quote')) {
        fitCards();
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitCards);
        var fitTimer; window.addEventListener('resize', function () { clearTimeout(fitTimer); fitTimer = setTimeout(fitCards, 150); });
      } else {
        measureLoop();
      }
      if (reduceMotion) return;
      var speed = parseFloat(getComputedStyle(vp.closest('.ticker, .tcards')).getPropertyValue('--ticker-speed')) || 25;
      // The drift moves the track with a sub-pixel transform (smooth), not scrollLeft (browsers round that to whole pixels, which stutters).
      var paused = false, resumeTimer = null, last = null, tx = 0, visible = true;
      track.style.willChange = 'transform';
      function fold() {
        if (!tx) return;
        var s = vp.scrollLeft + tx; tx = 0;
        track.style.transform = '';
        vp.scrollLeft = s;
      }
      function pause() { paused = true; clearTimeout(resumeTimer); fold(); }
      function userScroll() { vp.classList.add('is-user'); }
      function resumeSoon() {
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () {
          vp.classList.remove('is-user');
          if (loopWidth && vp.scrollLeft >= loopWidth) vp.scrollLeft -= loopWidth;
          paused = false;
        }, 700);
      }
      vp.addEventListener('touchstart', pause, { passive: true });
      vp.addEventListener('touchmove', userScroll, { passive: true });
      vp.addEventListener('touchend', resumeSoon, { passive: true });
      // No pause on mouse hover (Dennis, 2026-09-25): only a finger on a phone stops it.
      vp.addEventListener('focusin', pause);
      vp.addEventListener('focusout', resumeSoon);

      // A finger swipe keeps coasting after touchend: restart the countdown on every scroll the user makes
      vp.addEventListener('scroll', function () { if (paused) resumeSoon(); }, { passive: true });
      // Arrows (testimonial cards on desktop): one card per click, then the drift picks up again
      var frame = vp.parentNode;
      function nudge(dir) {
        pause();
        var card = track.children[0];
        var stepW = card ? card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 12) : vp.clientWidth * 0.8;
        if (dir < 0 && loopWidth && vp.scrollLeft < stepW) vp.scrollLeft += loopWidth;
        if (dir > 0 && loopWidth && vp.scrollLeft >= loopWidth * 2 - vp.clientWidth) vp.scrollLeft -= loopWidth;
        vp.scrollBy({ left: dir * stepW, behavior: 'smooth' });
        resumeSoon();
      }
      $all('.js-ticker-prev', frame).forEach(function (b) { b.addEventListener('click', function () { nudge(-1); }); });
      $all('.js-ticker-next', frame).forEach(function (b) { b.addEventListener('click', function () { nudge(1); }); });
      // No mouse drag on desktop: the strip only moves on its own and with the arrows.
      var lastCheck = 0;
      function checkVisible(ts) {
        if (ts - lastCheck < 400) return;
        lastCheck = ts;
        var r = vp.getBoundingClientRect();
        visible = r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight);
      }
      function step(ts) {
        if (last === null) last = ts;
        var dt = Math.min(ts - last, 64) / 1000;
        last = ts;
        checkVisible(ts);
        if (!paused && visible && !document.hidden) {
          tx += speed * dt;
          if (loopWidth && vp.scrollLeft + tx >= loopWidth) tx -= loopWidth;
          if (!loopWidth && vp.scrollLeft + tx + vp.clientWidth >= vp.scrollWidth - 1) tx = -vp.scrollLeft;
          track.style.transform = 'translate3d(' + (-tx).toFixed(2) + 'px,0,0)';
        } else if (paused) {
          if (loopWidth && vp.scrollLeft >= loopWidth * 2) vp.scrollLeft -= loopWidth;
        }
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }

  /* ---------- In her words slider: progress and count ---------- */
  function initSlider(root) {
    $all('.js-slider', root).forEach(function (s) {
      if (s.dataset.ready) return;
      s.dataset.ready = '1';
      var track = s.querySelector('.js-slider-track');
      var fill = s.querySelector('.js-slider-fill');
      var idx = s.querySelector('.js-slider-index');
      if (!track) return;
      var slides = $all('.js-slide', track);
      function update() {
        if (!slides.length) return;
        var w = slides[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 12);
        var max = track.scrollWidth - track.clientWidth;
        var i = max <= 1 ? 0 : Math.round(track.scrollLeft / w);
        if (max > 1 && track.scrollLeft >= max - 2) i = slides.length - 1;
        i = Math.min(Math.max(i, 0), slides.length - 1);
        if (idx) idx.textContent = String(i + 1);
        if (fill) fill.style.left = (i * (100 / slides.length)) + '%';
      }
      track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      // Desktop arrows: one card per click
      function stepBy(d) {
        var w = slides.length ? slides[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 12) : track.clientWidth;
        track.scrollBy({ left: d * w, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      var pv = s.querySelector('.js-slider-prev'), nx = s.querySelector('.js-slider-next');
      if (pv) pv.addEventListener('click', function () { stepBy(-1); });
      if (nx) nx.addEventListener('click', function () { stepBy(1); });
      update();
    });
  }

  /* ---------- Reviews (Judge.me layout): highest rating first, star picker, arrow pages, More, preview form ---------- */
  function initRevList(root) {
    $all('.rvs', root).forEach(function (sec) {
      if (sec.dataset.ready) return;
      sec.dataset.ready = '1';
      var list = sec.querySelector('.js-rvlist');
      if (!list) return;
      var items = $all('.js-rv', list);
      var per = parseInt(list.dataset.perPage, 10) || 10;
      var state = { sort: 'high', filter: 0, page: 0 };
      var pager = sec.querySelector('.js-rv-pager'), status = sec.querySelector('.js-rv-status');
      var prev = sec.querySelector('.js-rv-prev'), next = sec.querySelector('.js-rv-next');
      var empty = sec.querySelector('.js-rv-empty');
      function num(el, k) { return parseInt(el.dataset[k], 10) || 0; }
      function render(scroll) {
        var shown = items.filter(function (li) { return !state.filter || num(li, 'rating') === state.filter; });
        shown.sort(function (a, b) {
          if (state.sort === 'recent') return num(b, 'date') - num(a, 'date');
          var d = state.sort === 'low' ? num(a, 'rating') - num(b, 'rating') : num(b, 'rating') - num(a, 'rating');
          return d || (num(b, 'date') - num(a, 'date'));
        });
        items.forEach(function (li) { li.hidden = true; });
        var pages = Math.max(1, Math.ceil(shown.length / per));
        state.page = Math.min(state.page, pages - 1);
        shown.forEach(function (li, i) { list.appendChild(li); li.hidden = Math.floor(i / per) !== state.page; });
        if (empty) empty.hidden = shown.length > 0;
        if (pager) {
          pager.hidden = pages <= 1;
          if (status) status.textContent = 'Page ' + (state.page + 1) + ' of ' + pages;
          prev.disabled = state.page === 0; next.disabled = state.page >= pages - 1;
        }
        clampBodies();
        if (scroll) list.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }
      function clampBodies() {
        items.forEach(function (li) {
          if (li.hidden || li.dataset.clamped) return;
          li.dataset.clamped = '1';
          var body = li.querySelector('.js-rv-body'), more = li.querySelector('.js-rv-more');
          if (body && more && body.scrollHeight > body.clientHeight + 2) {
            more.hidden = false;
            more.addEventListener('click', function () { body.classList.add('is-open'); more.hidden = true; });
          }
        });
      }
      function panel(btnSel, panelSel) {
        var btn = sec.querySelector(btnSel), pnl = sec.querySelector(panelSel);
        if (!btn || !pnl) return;
        btn.addEventListener('click', function () {
          var open = pnl.hidden;
          $all('.rvs__panel', sec).forEach(function (p) { p.hidden = true; });
          $all('.js-rv-filter-btn, .js-rv-sort-btn', sec).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); b.classList.remove('is-on'); });
          pnl.hidden = !open; btn.setAttribute('aria-expanded', String(open)); btn.classList.toggle('is-on', open);
        });
      }
      panel('.js-rv-filter-btn', '.js-rv-filter');
      panel('.js-rv-sort-btn', '.js-rv-sort');
      var current = sec.querySelector('.js-rv-filter-current');
      $all('[data-filter]', sec).forEach(function (b) {
        b.addEventListener('click', function () {
          state.filter = parseInt(b.dataset.filter, 10) || 0; state.page = 0;
          $all('[data-filter]', sec).forEach(function (x) { x.classList.toggle('is-on', x === b); });
          if (current && b.dataset.label) current.textContent = b.dataset.label;
          var pnl = sec.querySelector('.js-rv-filter'), btn = sec.querySelector('.js-rv-filter-btn');
          if (pnl) pnl.hidden = true;
          if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.classList.remove('is-on'); }
          render(false);
        });
      });
      // Preview mode form: nothing is sent. Check the fields, show the thank you, clear the form.
      $all('.js-rv-local', sec).forEach(function (f) {
        f.addEventListener('submit', function (e) {
          e.preventDefault();
          if (f.reportValidity && !f.reportValidity()) return;
          var thanks = f.querySelector('.review-form__thanks');
          f.reset();
          $all('.field, .field-grid, .btn', f).forEach(function (el) { el.hidden = true; });
          if (thanks) { thanks.hidden = false; thanks.focus && thanks.setAttribute('tabindex', '-1'); thanks.focus(); }
        });
      });
      $all('[data-sort]', sec).forEach(function (b) {
        b.addEventListener('click', function () {
          state.sort = b.dataset.sort; state.page = 0;
          $all('[data-sort]', sec).forEach(function (x) { x.classList.toggle('is-on', x === b); });
          render(false);
        });
      });
      if (prev) prev.addEventListener('click', function () { state.page--; render(true); });
      if (next) next.addEventListener('click', function () { state.page++; render(true); });
      render(false);
    });
  }

  /* ---------- Sale countdown to a fixed end ---------- */
  function initSale() {
    $all('.js-sale').forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var daily = el.dataset.mode === 'daily';
      // Daily mode: the next midnight in Chicago (the store's time zone, daylight saving included, 2026-09-29), restarting each day.
      // data-offset (like -0500) is the fallback where the browser has no time zone data.
      function chicagoOff() {
        try {
          var now = new Date(), o = {};
          new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })
            .formatToParts(now).forEach(function (p) { o[p.type] = p.value; });
          var asUtc = Date.UTC(+o.year, +o.month - 1, +o.day, +o.hour % 24, +o.minute, +o.second);
          var off = Math.round((asUtc - now.getTime()) / 60000) * 60000;
          return isNaN(off) ? null : off;
        } catch (e) { return null; }
      }
      function nextMidnight() {
        var m = /^([+-])(\d{2})(\d{2})$/.exec(el.dataset.offset || '+0000');
        var off = chicagoOff();
        if (off === null) off = m ? (m[1] === '-' ? -1 : 1) * (parseInt(m[2], 10) * 60 + parseInt(m[3], 10)) * 60000 : 0;
        var day = 86400000, local = Date.now() + off;
        return Math.floor(local / day) * day + day - off;
      }
      var raw = el.dataset.end || '';
      var end = daily ? nextMidnight() : Date.parse(raw.replace(/([+-]\d{2})(\d{2})$/, '$1:$2'));
      if (isNaN(end)) { el.hidden = true; return; }
      var d = el.querySelector('.js-sale-d'), h = el.querySelector('.js-sale-h'), m = el.querySelector('.js-sale-m'), sc = el.querySelector('.js-sale-s');
      function two(n) { return String(n); } // no leading zero (Dennis, 2026-09-25): 3h 8m 56s
      function tick() {
        var left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) {
          if (daily) { end = nextMidnight(); left = Math.floor((end - Date.now()) / 1000); }
          else { el.hidden = true; clearInterval(timer); return; }
        }
        var days = Math.floor(left / 86400); left -= days * 86400;
        if (d) { d.hidden = days === 0; d.querySelector('b').textContent = two(days); }
        h.textContent = two(Math.floor(left / 3600)); m.textContent = two(Math.floor(left % 3600 / 60)); sc.textContent = two(left % 60);
      }
      var timer = setInterval(tick, 1000);
      tick();
    });
  }

  /* ---------- Warm-up: once the first screen is loaded and the phone is idle, fetch the photos further down
     so they are ready before she scrolls to them. Skipped when the visitor has Data Saver on.
     Gallery photos 4 onward and the desktop thumbnails keep their own rules. ---------- */
  function initWarmup() {
    var c = navigator.connection;
    if (c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ''))) return;
    function go() {
      $all('#MainContent img[loading="lazy"]').forEach(function (img) {
        if (img.closest('.gallery-thumbs') || img.hasAttribute('data-src') || img.hasAttribute('data-srcset')) return;
        img.loading = 'eager';
      });
    }
    function idle() { (window.requestIdleCallback || function (f) { setTimeout(f, 1500); })(go, { timeout: 3000 }); }
    if (document.readyState === 'complete') idle(); else window.addEventListener('load', idle);
  }

  /* ---------- Comparison arrow: its tip lands just above the guarantee's shield ---------- */
  function initCompareArrowDesk() {
    // Desktop arrow under the footnote. Its length is set for where the heading block comes to rest
    // (footnote level with the table's bottom): from there down to a little above the guarantee's shield.
    $all('.js-compare-arrow-desk').forEach(function (a) {
      var sec = a.closest('.shopify-section');
      var grid = sec && sec.querySelector('.compare__grid');
      var next = sec && sec.nextElementSibling;
      function size() {
        var target = next && (next.querySelector('.stitle__icon') || next.querySelector('.stitle') || next);
        if (!grid || !target || !a.offsetParent) return;
        var gap = parseFloat(getComputedStyle(a).top) - a.parentNode.getBoundingClientRect().height;
        var len = target.getBoundingClientRect().top - grid.getBoundingClientRect().bottom - gap - 40;
        a.style.height = Math.max(64, Math.round(len)) + 'px';
      }
      size();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(size);
      window.addEventListener('load', size);
      window.addEventListener('resize', size);
    });
  }

  function initCompareArrow() {
    $all('.js-compare-arrow').forEach(function (a) {
      var inner = a.querySelector('.compare__arrow-inner');
      var sec = a.closest('.shopify-section');
      var next = sec && sec.nextElementSibling;
      function size() {
        var target = next && (next.querySelector('.stitle__icon') || next.querySelector('.stitle') || next);
        if (!inner || !target) return;
        var len = target.getBoundingClientRect().top - inner.getBoundingClientRect().top - 12;
        inner.style.height = Math.max(64, Math.round(len)) + 'px';
      }
      size();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(size);
      window.addEventListener('load', size);
      window.addEventListener('resize', size);
    });
  }

  /* ---------- Sticky "Choose supply": only while the Reviews section fills the bottom of the screen ---------- */
  function initStickyBuy() {
    var bar = document.querySelector('.js-sticky-buy');
    if (!bar || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    var buy = document.querySelector('.pdp');
    var ticking = false;
    function check() {
      ticking = false;
      var show = false;
      if (buy && buy.getBoundingClientRect().bottom < 0) {
        var y = window.innerHeight - 40, hit = null;
        $all('#MainContent > .shopify-section').forEach(function (sec) {
          var r = sec.getBoundingClientRect();
          if (r.top <= y && r.bottom > y) hit = sec;
        });
        if (hit && hit.querySelector('.rvs')) show = true; // only while scrolling through the Reviews
      }
      bar.classList.toggle('is-on', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var a = bar.querySelector('a'); if (a) a.tabIndex = show ? 0 : -1;
    }
    function queue() { if (!ticking) { ticking = true; requestAnimationFrame(check); } }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    check();
  }

  /* ---------- Testimonial cards: dots follow the swipe ---------- */
  function initTcards(root) {
    $all('.js-tcards', root).forEach(function (track) {
      if (track.dataset.ready) return;
      track.dataset.ready = '1';
      var dots = $all('.tcards__dot', track.parentNode);
      var cards = $all('.tcard', track);
      if (!dots.length || !cards.length) return;
      function update() {
        var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bestD = Infinity;
        cards.forEach(function (c, i) { var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid); if (d < bestD) { bestD = d; best = i; } });
        dots.forEach(function (d, i) { d.classList.toggle('is-on', i === best); });
      }
      track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      update();
    });
  }

  /* ---------- Desktop gallery thumbnails ---------- */
  function initThumbs(root) {
    $all('.js-thumbs', root).forEach(function (row) {
      if (row.dataset.ready) return;
      row.dataset.ready = '1';
      var track = row.parentNode.querySelector('.js-gallery-track');
      if (!track) return;
      var thumbs = $all('.gallery-thumb', row);
      // Thumbnails are desktop only: give their images a src only once the row is actually visible
      function showThumbs() {
        if (!row.offsetParent) return false;
        $all('img[data-src], img[data-srcset]', row).forEach(function (img) {
          if (img.dataset.srcset) { img.srcset = img.dataset.srcset; img.removeAttribute('data-srcset'); }
          if (img.dataset.src) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
        });
        return true;
      }
      if (!showThumbs()) {
        var onResize = function () { if (showThumbs()) window.removeEventListener('resize', onResize); };
        window.addEventListener('resize', onResize);
      }
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' }); });
      });
      function mark() { var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); thumbs.forEach(function (t, j) { t.classList.toggle('is-on', i === j); t.setAttribute('aria-current', i === j ? 'true' : 'false'); }); }
      track.addEventListener('scroll', function () { requestAnimationFrame(mark); }, { passive: true });
      mark();
    });
  }

  /* ---------- Reviews: 5 stars first down to 1, 10 per page, write a review toggle ---------- */
  function initReviews(root) {
    $all('.js-review-toggle', root).forEach(function (btn) {
      if (btn.dataset.ready) return;
      btn.dataset.ready = '1';
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      btn.addEventListener('click', function () {
        var open = panel.hidden;
        panel.hidden = !open;
        btn.setAttribute('aria-expanded', String(open));
        if (open) { var f = panel.querySelector('input:not([type=hidden]), textarea'); if (f) f.focus(); }
      });
      if (/contact_posted=true/.test(location.search) || panel.querySelector('.review-form__thanks:not([hidden]), .review-form__errors')) {
        panel.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
      }
    });
    $all('.js-reviews', root).forEach(function (list) {
      if (list.dataset.ready) return;
      list.dataset.ready = '1';
      var items = $all('.js-review', list);
      // 5 stars first, down to 1. Inside a star level: featured first, then the fullest review, then newest.
      function num(el, k) { return parseInt(el.dataset[k], 10) || 0; }
      items.sort(function (a, b) {
        return (num(b, 'rating') - num(a, 'rating')) || (num(b, 'featured') - num(a, 'featured')) ||
          (num(b, 'len') - num(a, 'len')) || (num(b, 'date') - num(a, 'date'));
      });
      items.forEach(function (li) { list.appendChild(li); });
      var per = parseInt(list.dataset.perPage, 10) || 10;
      var pages = Math.ceil(items.length / per);
      var nav = list.parentNode.querySelector('.js-pager');
      if (pages <= 1 || !nav) return;
      var prev = nav.querySelector('.js-pager-prev'), next = nav.querySelector('.js-pager-next'), status = nav.querySelector('.js-pager-status');
      var page = 0;
      function show(p, scroll) {
        page = Math.min(Math.max(p, 0), pages - 1);
        items.forEach(function (li, i) { li.hidden = Math.floor(i / per) !== page; });
        status.textContent = 'Page ' + (page + 1) + ' of ' + pages;
        prev.disabled = page === 0;
        next.disabled = page === pages - 1;
        if (scroll) list.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }
      prev.addEventListener('click', function () { show(page - 1, true); });
      next.addEventListener('click', function () { show(page + 1, true); });
      nav.hidden = false;
      show(0, false);
    });
  }

  /* ---------- Keep section backgrounds alternating when a section hides itself (logic inline in theme.liquid) ---------- */
  function initAlternate() { if (typeof window.vosoroAlternate === 'function') window.vosoroAlternate(); }

  function init(root) {
    initDrawer();
    initGallery(root);
    initSupply(root);
    initScrollToBuy();
    initTicker(root);
    initSlider(root);
    initReviews(root);
    initTcards(root);
    initCompareArrow();
    initCompareArrowDesk();
    initStickyBuy();
    initWarmup();
    initSale();
    initRevList(root);
    initThumbs(root);
    initAlternate();
  }

  /* ---------- No copying text on the store (Dennis, 2026-09-25). Form fields still work. ---------- */
  document.addEventListener('copy', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('input, textarea, [contenteditable]')) return;
    e.preventDefault();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  // Theme editor: re-run when a section is added or changed.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
